import React from 'react'

export const PinterestIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style}
    className={`icon--social icon--social-pinterest ${props.className || ''}`}
    viewBox='0 0 32 32'
  >
    <path
      d='M8.884,29.334c-0.05-1.209-0.01-2.662,0.313-3.984c0.346-1.408,2.323-9.458,2.323-9.458s-0.577-1.11-0.577-2.748c0-2.572,1.55-4.495,3.478-4.495c1.644,0,2.436,1.187,2.436,2.607c0,1.587-1.054,3.961-1.594,6.161c-0.451,1.843,0.96,3.343,2.847,3.343c3.417,0,5.723-4.222,5.723-9.23c0-3.805-2.667-6.653-7.51-6.653c-5.47,0-8.881,3.928-8.881,8.315c0,1.513,0.463,2.58,1.189,3.405c0.335,0.38,0.38,0.534,0.26,0.97c-0.085,0.316-0.285,1.086-0.369,1.392c-0.12,0.438-0.49,0.595-0.901,0.433c-2.522-0.989-3.696-3.645-3.696-6.631c0-4.932,4.322-10.847,12.895-10.847c6.887,0,11.421,4.796,11.421,9.946c0,6.809-3.936,11.897-9.733,11.897c-1.949,0-3.782-1.014-4.409-2.164c0,0-1.047,4.004-1.27,4.777c-0.381,1.338-1.129,2.674-1.815,3.719'
    />
  </svg>
)
